module.exports = __webpack_public_path__ + "static/media/news.8a6b026a.png";